module.exports = __webpack_public_path__ + "img/ring_y_skip_null_null@3x.f6829922.png";